import { Action } from '../../../common/actions/core/action';

export class OtpAction implements Action {
  constructor(public msisdn: string, public approved: () => any) {}
}


// WEBPACK FOOTER //
// src/app/no-auth/components/otp-dialog/otp-dialog.action.ts